import { render, staticRenderFns } from "./frontConfiguracionContainer.vue?vue&type=template&id=4ab9f3be&scoped=true&"
import script from "./frontConfiguracionContainer.vue?vue&type=script&lang=js&"
export * from "./frontConfiguracionContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ab9f3be",
  null
  
)

export default component.exports